import type { ReactNode } from 'react';
import { statusEntry, toneStyle } from './statusMap';

/**
 * VFStatusTag — a static status pill read from the one status map (D9,
 * DESIGN.md §3): colour and icon from `statusMap`, the label given by the
 * caller (always translated, e.g. `outcomeLabel()`). Colour never carries
 * the meaning alone: the icon and the label do too. QA-W5-2: the portal's
 * Prospects tab showed raw values (`completed`) and empty pills.
 */
interface VFStatusTagProps {
  /** A key of STATUS_MAP; an unknown key gets the neutral style. */
  status: string | null | undefined;
  label: ReactNode;
  className?: string;
}

export function VFStatusTag({ status, label, className = '' }: VFStatusTagProps) {
  const entry = statusEntry(status);
  const style = toneStyle(entry.tone);
  const Icon = entry.icon;
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-vf-sm px-2 h-6 text-[11px] font-semibold ${className}`}
      style={{ background: style.bg, color: style.fg, border: `1px solid ${style.bd}` }}
      data-status={status ?? ''}
    >
      <Icon width={12} height={12} aria-hidden />
      <span>{label}</span>
    </span>
  );
}

export default VFStatusTag;
